<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
@import "./assets/css/common.scss";
  body{
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// App.vue?b474ae56